"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SingleWomanCheck: ['single-woman-check', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,6.75a6,6,0,1,1-6-6', 'M23.25,2.249l-5.47,5.47a.749.749,0,0,1-1.06,0L15,6', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3']],
  SingleWomanFlag1: ['single-woman-flag-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.75 0.75L0.75 23.25', 'M11.25 9.75L0.75 9.75 0.75 2.25 11.25 2.25 7.5 6 11.25 9.75z', 'M15.750 3.750 A3.000 3.000 0 1 0 21.750 3.750 A3.000 3.000 0 1 0 15.750 3.750 Z', 'M21.534,9.216,18.75,12.75,15.966,9.216A4.489,4.489,0,0,0,14.25,12.75v3h1.5l.75,7.5H21l.75-7.5h1.5v-3A4.489,4.489,0,0,0,21.534,9.216Z', 'M15.75,3.75s0,3-1.5,3', 'M21.75,3.75s0,3,1.5,3']],
  SingleWomanCircle: ['single-woman-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z', 'M9.750 6.000 A2.250 2.250 0 1 0 14.250 6.000 A2.250 2.250 0 1 0 9.750 6.000 Z', 'M14.25,10.5,12,12.75,9.75,10.5a3.743,3.743,0,0,0-1.5,3v2.25h1.5l.75,4.5h3l.75-4.5h1.5V13.5A3.743,3.743,0,0,0,14.25,10.5Z', 'M9.75,6s0,2.25-1.5,2.25', 'M14.25,6s0,2.25,1.5,2.25']],
  SingleWomanDecrease: ['single-woman-decrease', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25 0.75L15.75 5.25 18.75 2.25 23.25 6.75', 'M23.25 3L23.25 6.75 19.5 6.75', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3', 'M8.25,3.75s0,3,1.5,3']],
  SingleWomanIdea: ['single-woman-idea', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.125 9.75L19.125 12', 'M22.875,4.5a3.75,3.75,0,1,0-5.25,3.437V9.75h3V7.937A3.751,3.751,0,0,0,22.875,4.5Z', 'M2.625 3.750 A3.000 3.000 0 1 0 8.625 3.750 A3.000 3.000 0 1 0 2.625 3.750 Z', 'M8.409,9.216,5.625,12.75,2.841,9.216A4.489,4.489,0,0,0,1.125,12.75v3h1.5l.75,7.5h4.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.409,9.216Z', 'M2.625,3.75s0,3-1.5,3', 'M8.625,3.75s0,3,1.5,3']],
  SingleWomanIncrease: ['single-woman-increase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.25 6.75L15.75 2.25 18.75 5.25 23.25 0.75', 'M23.25 4.5L23.25 0.75 19.5 0.75', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3']],
  SingleWomanMegaphone: ['single-woman-megaphone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.318,8.557,14.25,6.54V2.79L22.318.773a.749.749,0,0,1,.932.727V7.829A.751.751,0,0,1,22.318,8.557Z', 'M14.25 1.29L14.25 8.04', 'M17.25,7.29v.628A3.291,3.291,0,0,0,19.5,11.04h0', 'M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M8.886,9.114,6,13.5,3.114,9.114A5.246,5.246,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5L9,15.75h2.25V13.5A5.246,5.246,0,0,0,8.886,9.114Z', 'M3,3.75S3,7.5.75,7.5', 'M9,3.75S9,7.5,11.25,7.5']],
  SingleWomanMail: ['single-woman-mail', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,2.25v6a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1-1.5-1.5v-6', 'M23.25,2.25a1.5,1.5,0,0,0-1.5-1.5h-9a1.5,1.5,0,0,0-1.5,1.5l5.2,3.253a1.5,1.5,0,0,0,1.59,0Z', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3']],
  SingleWomanQuestion: ['single-woman-question', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 6.750 A6.000 6.000 0 1 0 23.250 6.750 A6.000 6.000 0 1 0 11.250 6.750 Z', 'M15.375,5.625A1.875,1.875,0,1,1,17.25,7.5', 'M17.25,9.75a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3']],
  SingleWomanProcess: ['single-woman-process', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.250 14.250 A3.000 3.000 0 1 0 23.250 14.250 A3.000 3.000 0 1 0 17.250 14.250 Z', 'M11.25 0.75L15.75 5.25', 'M15.75 0.75L11.25 5.25', 'M18.75 2.25L23.25 2.25 23.25 6.75', 'M23.25 2.25L12.75 12', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3']],
  SingleWomanShoppingBag: ['single-woman-shopping-bag', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M9.552,11.441A4.534,4.534,0,0,0,8.07,9.269L5.25,13.5,2.43,9.269A4.471,4.471,0,0,0,.75,12.75v3H2.326l.75,7.5H7.424l.524-5.237', 'M2.25,3.75S2.25,7.5.75,7.5', 'M8.25,3.75s0,3.75,1.5,3.75', 'M23.25 23.25L11.25 23.25 12.75 12.75 21.75 12.75 23.25 23.25z', 'M15,15.75V10.5a2.25,2.25,0,0,1,4.5,0v5.25']],
  SingleWomanStatics1: ['single-woman-statics-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,14.25h9a1.5,1.5,0,0,0,1.5-1.5V2.25a1.5,1.5,0,0,0-1.5-1.5H11.25', 'M12 9L14.25 5.25 17.25 8.25 20.25 3.75', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3', 'M8.25,3.75s0,3,1.5,3']],
  SingleWomanStatics3: ['single-woman-statics-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,14.25h9a1.5,1.5,0,0,0,1.5-1.5V2.25a1.5,1.5,0,0,0-1.5-1.5H11.25', 'M15.75,11.25v-6a1.5,1.5,0,0,1,3,0v6', 'M15.75 8.25L18.75 8.25', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3', 'M8.25,3.75s0,3,1.5,3']],
  SingleWomanShield: ['single-woman-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,5.25a7.669,7.669,0,0,1-6,7.5,7.669,7.669,0,0,1-6-7.5v-3a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5Z', 'M17.25 4.5L17.25 9', 'M15 6.75L19.5 6.75', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3']],
  SingleWomanTime: ['single-woman-time', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 6.750 A6.000 6.000 0 1 0 23.250 6.750 A6.000 6.000 0 1 0 11.250 6.750 Z', 'M19.902 6.75L17.25 6.75 17.25 4.098', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3']],
  SingleWomanMoney: ['single-woman-money', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,3.75H16.717a1.342,1.342,0,0,0-.5,2.587l2.064.825a1.342,1.342,0,0,1-.5,2.588H15.75', 'M17.25 3.754L17.25 3', 'M17.25 10.5L17.25 9.754', 'M11.250 6.750 A6.000 6.000 0 1 0 23.250 6.750 A6.000 6.000 0 1 0 11.250 6.750 Z', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3']],
  SingleWoman: ['single-woman', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 Z', 'M14.25,23.25l.75-7.5h2.25V13.5a5.246,5.246,0,0,0-2.364-4.386L12,13.5,9.114,9.114A5.246,5.246,0,0,0,6.75,13.5v2.25H9l.75,7.5Z', 'M9,3.75S9,7.5,6.75,7.5', 'M15,3.75S15,7.5,17.25,7.5']],
  SingleWomanChat: ['single-woman-chat', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M8.25,23.25,9,15.75h2.25V13.5A5.246,5.246,0,0,0,8.886,9.114L6,13.5,3.114,9.114A5.246,5.246,0,0,0,.75,13.5v2.25H3l.75,7.5Z', 'M3,3.75S3,7.5.75,7.5', 'M9,3.75S9,7.5,11.25,7.5', 'M14.25,6.75H16.5v3l3.75-3H22.5A.75.75,0,0,0,23.25,6V1.5A.75.75,0,0,0,22.5.75H14.25a.75.75,0,0,0-.75.75V6A.75.75,0,0,0,14.25,6.75Z']],
  SingleWomanFlag2: ['single-woman-flag-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M9.756,9.833a5.222,5.222,0,0,0-.87-.719L6,13.5,3.114,9.114A5.246,5.246,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5L9,15.75h.75', 'M3,3.75S3,7.5.75,7.5', 'M9,3.75s0,2.527,1.245,3.432', 'M12.75 9L12.75 23.25', 'M12.75,17.267l1.505-.509A4.249,4.249,0,0,1,18,17.267a4.246,4.246,0,0,0,3.745.509l1.5-.509V8.983l-1.5.508A4.249,4.249,0,0,1,18,8.983a4.246,4.246,0,0,0-3.745-.509l-1.505.509Z']],
  SingleWomanStatis2: ['single-woman-statis-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,14.25h9a1.5,1.5,0,0,0,1.5-1.5V2.25a1.5,1.5,0,0,0-1.5-1.5H11.25', 'M20.25 11.25L12.75 11.25', 'M15.75 6.75H18.75V11.25H15.75z', 'M15.75 11.25L15.75 3.75 12.75 3.75 12.75 6.75', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3', 'M8.25,3.75s0,3,1.5,3']],
  SingleWomanBriefcase: ['single-woman-briefcase', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M10.744,11.249A5.276,5.276,0,0,0,8.886,9.114L6,13.5,3.114,9.114A5.246,5.246,0,0,0,.75,13.5v2.25H3l.75,7.5h4.5l.281-2.81', 'M3,3.75S3,7.5.75,7.5', 'M9,3.75S9,7.5,11.25,7.5', 'M11.250 14.250 L23.250 14.250 L23.250 23.250 L11.250 23.250 Z', 'M11.25 17.25L23.25 17.25', 'M17.25 17.25L17.25 18.75', 'M18,11.25H16.5a1.5,1.5,0,0,0-1.5,1.5v1.5h4.5v-1.5A1.5,1.5,0,0,0,18,11.25Z']],
  SingleWomanHeart: ['single-woman-heart', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25,11.25,12.136,5.915a3.023,3.023,0,0,1-.566-3.492h0a3.025,3.025,0,0,1,4.845-.787l.835.835.835-.835a3.026,3.026,0,0,1,4.846.787h0a3.025,3.025,0,0,1-.567,3.492Z', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3', 'M8.25,3.75s0,3,1.5,3']],
  SingleWomanSetting: ['single-woman-setting', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.750 7.500 A1.500 1.500 0 1 0 18.750 7.500 A1.500 1.500 0 1 0 15.750 7.500 Z', 'M18.524,1.7l.442,1.453a1,1,0,0,0,1.174.681l1.472-.342a1.339,1.339,0,0,1,1.275,2.219L21.856,6.819a1,1,0,0,0,0,1.362l1.031,1.111a1.339,1.339,0,0,1-1.275,2.218l-1.472-.341a.993.993,0,0,0-1.174.681L18.524,13.3a1.33,1.33,0,0,1-2.548,0l-.442-1.452a.993.993,0,0,0-1.174-.681l-1.472.341a1.339,1.339,0,0,1-1.275-2.218l1.031-1.111a1,1,0,0,0,0-1.362L11.613,5.708a1.339,1.339,0,0,1,1.275-2.219l1.472.342a1,1,0,0,0,1.174-.681L15.976,1.7A1.33,1.33,0,0,1,18.524,1.7Z', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3']],
  SingleWomanHierachy: ['single-woman-hierachy', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.750 0.750 L23.250 0.750 L23.250 5.250 L18.750 5.250 Z', 'M18.750 9.750 L23.250 9.750 L23.250 14.250 L18.750 14.250 Z', 'M18.750 18.750 L23.250 18.750 L23.250 23.250 L18.750 23.250 Z', 'M18.75 11.25L12.75 11.25', 'M18.75,2.25h-1.5a1.5,1.5,0,0,0-1.5,1.5v15a1.5,1.5,0,0,0,1.5,1.5h1.5', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3', 'M8.25,3.75s0,3,1.5,3']],
  SingleWomanAim: ['single-woman-aim', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25 0.75L17.25 3.75', 'M17.25 9.75L17.25 12.75', 'M11.25 6.75L14.25 6.75', 'M23.25 6.75L20.25 6.75', 'M12.750 6.750 A4.500 4.500 0 1 0 21.750 6.750 A4.500 4.500 0 1 0 12.750 6.750 Z', 'M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M8.034,9.216,5.25,12.75,2.466,9.216A4.489,4.489,0,0,0,.75,12.75v3h1.5L3,23.25H7.5l.75-7.5h1.5v-3A4.489,4.489,0,0,0,8.034,9.216Z', 'M2.25,3.75s0,3-1.5,3']]
};
exports["default"] = _default;